export default function CRIStatementController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  serviceIds,
  attachStatementDialog,
  docDataService,
) {
  const vm = this;

  vm.canIncludeInActionPlan = vm.criStatement.criAssessment.canIncludeInActionPlan;

  // Set Default Values
  vm.serviceId = serviceIds.eCat;
  vm.handleExpandCRIStatement = _handleExpandCRIStatement;

  // Attach Event Handlers
  vm.handleSelectedChange = _handleSelectedChange;
  vm.handleAttachItems = _handleAttachItems;
  vm.changedToNotInclude = false;
  vm.handleNotesChange = _handleNotesChange;
  vm.documentAttached = _documentAttached;
  vm.handleAchievementLevelChange = _handleAchievementLevelChange;
  vm.handleCurrentMaturityLevelChange = _handleCurrentMaturityLevelChange;
  vm.handleDesiredMaturityLevelChange = _handleDesiredMaturityLevelChange;

  vm.currentAchievementLevelValue = -1;
  vm.currentCurrentMaturityLevelValue = -1;
  vm.currentDesiredMaturityLevelValue = -1;

  _activate();

  _initEventListeners();

  // //////// METHODS //////////

  function _activate() {
    vm.maturityLevels = ecatSharedModelService.maturityLevels;
    vm.achievementLevels = ecatSharedModelService.achievementLevels;

    vm.currentAchievementLevelValue = vm.criStatement.criAssessment.achievementLevelId;
    vm.currentCurrentMaturityLevelValue = vm.criStatement.criAssessment.currentMaturityLevelId;
    vm.currentDesiredMaturityLevelValue = vm.criStatement.criAssessment.desiredMaturityLevelId;

    _setCanSetIncludeInActionPlan();

    vm.settableAchievementLevels = [];
    angular.forEach(ecatSharedModelService.achievementLevels, achievementLevel => {
      if (achievementLevel.achievementLevelId !== 4) {
        vm.settableAchievementLevels.push(achievementLevel);
      }
    });

    return userService.getUserPermissionSet('ecat').then(permissions => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
    $scope.$on('refreshCRIStatement', (event, opt) => {
      if (opt.criStatementId === vm.criStatement.criStatementId) {
        _refreshCRIStatement();
      }
    });

    $scope.$on('refreshCRIStatementFolders', (event, opt) => {
      if (opt.criStatementId === vm.criStatement.criStatementId) {
        _refreshCRIStatementFolders();
      }
    });

    $scope.$on('refreshCRIStatementDocuments', (event, opt) => {
      if (opt.criStatementId === vm.criStatement.criStatementId) {
        _refreshCRIStatementDocuments();
      }
    });

    $scope.$on('refreshFolderAttachments', () => {
      _refreshCRIStatementFolders();
      _refreshCRIStatementDocuments();
    });

    $scope.$on('refreshDocAttachments', (event, opt) => {
      let docisAttached = false;
      angular.forEach(vm.criStatement.criStatementDocuments, statementDocument => {
        if (statementDocument.documentId === opt.document.documentId) {
          docisAttached = true;
        }
      });

      if (docisAttached) {
        _refreshCRIStatementDocuments();
      }
    });
  }

  function _handleExpandCRIStatement() {
    vm.isCRIStatementExpanded = !vm.isCRIStatementExpanded;
  }

  function _handleAttachItems($event) {
    loaderService.showViewLoader = true;
    docDataService.getFolderProperties(-1).then(getFolderResponse => {
      vm.rootFolder = getFolderResponse.data;

      ssDialogService.dialogs.ecat.attachStatementDialog = ssDialogService.alert(
        attachStatementDialog.getOptions($event, {
          serviceId: vm.serviceId,
          criStatementId: vm.criStatement.criStatementId,
          folder: vm.rootFolder,
          attachCallback: vm.documentAttached,
          assessmentId: vm.assessmentId,
        }),
      );
      ssDialogService.show(ssDialogService.dialogs.ecat.attachStatementDialog);
    });
  }

  function _documentAttached() {
    $rootScope.$broadcast('refreshCRIStatement', { criStatementId: vm.criStatement.criStatementId });
  }

  function _handleSelectedChange() {
    let oldValue = -1;
    let newValue = -1;

    if (vm.criStatement.criAssessment.includeInAssessment == false) {
      vm.changedToNotInclude = true;

      oldValue = vm.currentAchievementLevelValue;
      newValue = 4;

      vm.currentAchievementLevelValue = 4;
    } else {
      vm.changedToNotInclude = false;

      oldValue = 4;
      newValue = 1;

      vm.currentAchievementLevelValue = 1;
    }

    $rootScope.$broadcast('updateCounts', {
      criFunctionId: vm.criFunctionId,
      criCategoryId: vm.criCategoryId,
      criSubCategoryId: vm.criSubCategoryId,
      add: newValue,
      remove: oldValue,
    });
  }

  function _handleNotesChange() {
    if (vm.criStatement.criAssessment.note) {
      vm.changedToNotInclude = false;
    }
  }

  function _handleAchievementLevelChange() {
    if (vm.criStatement.criStatementId > 0) {
      const oldValue = vm.currentAchievementLevelValue;
      const newValue = vm.criStatement.criAssessment.achievementLevelId;

      vm.currentAchievementLevelValue = vm.criStatement.criAssessment.achievementLevelId;

      $rootScope.$broadcast('updateCounts', {
        criFunctionId: vm.criFunctionId,
        criCategoryId: vm.criCategoryId,
        criSubCategoryId: vm.criSubCategoryId,
        add: newValue,
        remove: oldValue,
      });

      _setCanSetIncludeInActionPlan();

      return;
    }
  }

  function _handleCurrentMaturityLevelChange() {
    if (vm.criStatement.criStatementId > 0) {
      vm.currentCurrentMaturityLevelValue = vm.criStatement.criAssessment.currentMaturityLevelId;
      _setCanSetIncludeInActionPlan();
      return;
    }
  }

  function _handleDesiredMaturityLevelChange() {
    if (vm.criStatement.criStatementId > 0) {
      vm.currentDesiredMaturityLevelValue = vm.criStatement.criAssessment.desiredMaturityLevelId;
      _setCanSetIncludeInActionPlan();
      return;
    }
  }

  function _setCanSetIncludeInActionPlan() {
    if (
      vm.currentAchievementLevelValue === 3 &&
      vm.currentCurrentMaturityLevelValue >= vm.currentDesiredMaturityLevelValue
    ) {
      vm.canIncludeInActionPlan = false;
      vm.criStatement.criAssessment.canIncludeInActionPlan = false;
    } else {
      vm.canIncludeInActionPlan = true;
      vm.criStatement.criAssessment.canIncludeInActionPlan = true;
    }
  }

  function _refreshCRIStatementDocuments() {
    const dfdRefresh = $q.defer();

    ecatDataService
      .getCRIStatementDocumentsByStatement(vm.assessmentId, vm.criStatement.criStatementId)
      .then(response => {
        vm.criStatement.criStatementDocuments = response.data.result;
        dfdRefresh.resolve();
      });

    return dfdRefresh.promise;
  }

  function _refreshCRIStatementFolders() {
    const dfdRefresh = $q.defer();

    ecatDataService
      .getCRIStatementFoldersByStatement(vm.assessmentId, vm.criStatement.criStatementId)
      .then(response => {
        vm.criStatement.criStatementFolders = response.data.result;
        dfdRefresh.resolve();
      });

    return dfdRefresh.promise;
  }

  function _refreshCRIStatement() {
    const dfdRefresh = $q.defer();

    ecatDataService.getCRIStatement(vm.criStatement.criStatementId).then(response => {
      vm.criStatement = response.data.result;
      //_setStatuses();
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }
}

CRIStatementController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'confirmDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'userService',
  'serviceIds',
  'attachStatementDialog',
  'docDataService',
];
